export default __webpack_public_path__ + "static/RookTKO-6fd9c82e87dbcff83d1c58a1d0b22003.png";